type Config = {
  REACT_APP_BASE_URL: string;
  REACT_APP_AUTH_DOMAIN: string;
  REACT_APP_PREFERENCE_SERVICE_URL: string;
  REACT_APP_PATHWAY_SERVICE_URL: string;
  REACT_APP_UNIVERSAL_COOKIE_PATHNAME: string;
  CALENDAR_INTEGRATION_SERVICE_URL: string;
  CLIENT_ID: string;
  APP_NAME: string;
  VIEWS_URL: string;
  NOTIFICATION_KEY: string;
  LAUNCH_DARKLY_CLIENT_ID: string;
};

export const configs: Record<string, Config> = {
  development: {
    REACT_APP_BASE_URL: 'http://localhost:3010/v1',
    REACT_APP_AUTH_DOMAIN: 'http://localhost:3000',
    REACT_APP_PREFERENCE_SERVICE_URL:
      'https://preferences.|_REGION_|.timeedit.dev/v1/',
    REACT_APP_PATHWAY_SERVICE_URL: 'http://localhost:3026/v1',
    REACT_APP_UNIVERSAL_COOKIE_PATHNAME: '/',
    CALENDAR_INTEGRATION_SERVICE_URL:
      import.meta.env.VITE_CALENDAR_INTEGRATION_SERVICE_URL ??
      'http://localhost:4102',
    CLIENT_ID: 'teAdmin',
    APP_NAME: 'teAdmin',
    VIEWS_URL: 'https://views.timeedit.io/v1',
    NOTIFICATION_KEY: 'TE_ADMIN_NOTIFICATION',
    LAUNCH_DARKLY_CLIENT_ID: '65e829cc7386bf105e2e28d5',
  },
  beta: {
    REACT_APP_BASE_URL: 'https://api.timeedit.dev/v1',
    REACT_APP_AUTH_DOMAIN: 'https://timeedit.dev',
    REACT_APP_PREFERENCE_SERVICE_URL:
      'https://preferences.|_REGION_|.timeedit.dev/v1/',
    REACT_APP_PATHWAY_SERVICE_URL: 'https://pathway.timeedit.dev/v1',
    REACT_APP_UNIVERSAL_COOKIE_PATHNAME: 'timeedit.io',
    CALENDAR_INTEGRATION_SERVICE_URL:
      import.meta.env.VITE_CALENDAR_INTEGRATION_SERVICE_URL ??
      'https://calendar-integration.timeedit.dev',
    CLIENT_ID: 'teAdmin',
    APP_NAME: 'teAdmin',
    VIEWS_URL: 'https://views-beta.timeedit.io/v1',
    NOTIFICATION_KEY: 'TE_ADMIN_NOTIFICATION',
    LAUNCH_DARKLY_CLIENT_ID: '65e829cc7386bf105e2e28d5',
  },
  staging: {
    REACT_APP_BASE_URL: 'https://api.timeedit.io/v1',
    REACT_APP_AUTH_DOMAIN: 'https://timeedit.io',
    REACT_APP_PREFERENCE_SERVICE_URL:
      'https://preferences.|_REGION_|.timeedit.io/v1/',
    REACT_APP_PATHWAY_SERVICE_URL: 'https://pathway.timeedit.io/v1',
    REACT_APP_UNIVERSAL_COOKIE_PATHNAME: 'timeedit.io',
    CALENDAR_INTEGRATION_SERVICE_URL:
      import.meta.env.VITE_CALENDAR_INTEGRATION_SERVICE_URL ??
      'https://calendar-integration.timeedit.io',
    CLIENT_ID: 'teAdmin',
    APP_NAME: 'teAdmin',
    VIEWS_URL: 'https://views.timeedit.com/v1',
    NOTIFICATION_KEY: 'TE_ADMIN_NOTIFICATION',
    LAUNCH_DARKLY_CLIENT_ID: '65e829836880eb10b9f4edca',
  },
  test: {
    REACT_APP_BASE_URL: 'https://api.test.timeedit.net/v1',
    REACT_APP_AUTH_DOMAIN: 'https://test.timeedit.net',
    REACT_APP_PREFERENCE_SERVICE_URL:
      'https://preferences.|_REGION_|.test.timeedit.net/v1/',
    REACT_APP_PATHWAY_SERVICE_URL: 'https://pathway.test.timeedit.net/v1',
    REACT_APP_UNIVERSAL_COOKIE_PATHNAME: 'timeedit.net',
    CALENDAR_INTEGRATION_SERVICE_URL:
      import.meta.env.VITE_CALENDAR_INTEGRATION_SERVICE_URL ??
      'https://calendar-integration.test.timeedit.net',
    CLIENT_ID: 'teAdmin',
    APP_NAME: 'teAdmin',
    VIEWS_URL: 'https://views.test.timeedit.com/v1',
    NOTIFICATION_KEY: 'TE_ADMIN_NOTIFICATION',
    LAUNCH_DARKLY_CLIENT_ID: '67ab2b0fbad72e0a5478c6a6',
  },
  production: {
    REACT_APP_BASE_URL: 'https://api.timeedit.net/v1',
    REACT_APP_AUTH_DOMAIN: 'https://timeedit.net',
    REACT_APP_PREFERENCE_SERVICE_URL:
      'https://preferences.|_REGION_|.timeedit.net/v1/',
    REACT_APP_PATHWAY_SERVICE_URL: 'https://pathway.timeedit.net/v1',
    REACT_APP_UNIVERSAL_COOKIE_PATHNAME: 'timeedit.net',
    CALENDAR_INTEGRATION_SERVICE_URL:
      import.meta.env.VITE_CALENDAR_INTEGRATION_SERVICE_URL ??
      'https://calendar-integration.timeedit.net',
    CLIENT_ID: 'teAdmin',
    APP_NAME: 'teAdmin',
    VIEWS_URL: 'https://views.timeedit.com/v1',
    NOTIFICATION_KEY: 'TE_ADMIN_NOTIFICATION',
    LAUNCH_DARKLY_CLIENT_ID: '65a938f0183d141061d386f9',
  },
};
